<template>
  <div class="lableSearch">
    <a href="/">
      <el-image class="logo_search" :src="carouselItems" lazy></el-image>
    </a>
    <div class="search">
      <div
        class="search_header"
        @mouseover="() => (show = true)"
        @mouseout="() => (show = false)"
      >
        <i class="el-icon-menu"></i>
        <span style="margin: 0 10px">所有商品分类</span>
        <i :class="show ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
        <template v-if="showLabel">
          <div v-show="show">
            <ProductBrowser />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/vuex/store";
import ProductBrowser from '../../views/home/components/ProductBrowser.vue'
export default {
  data () {
    return {
      show: false,
      showLabel: false
    }
  },
  components: { ProductBrowser },
  computed: {
    carouselItems () {
      let carouselItems = store.state.HomeBanner.find(item => item.type === 8);
      return carouselItems && carouselItems.list && carouselItems.list[0] ? carouselItems.list[0].imageUrl : ""
    },
  },
  watch: {
    '$route': {
      handler (val, old) {
        this.showLabel = val.path !== '/';
      },
      deep: true, // 深度监听
      immediate: true, // 初次监听即执行
    }
  }
}
</script>

<style scoped lang="scss">
.lableSearch {
  .logo_search {
    width: 180px;
    position: absolute;
    left: -22px;
  }
  .search {
    position: absolute;
    left: -22px;
    bottom: 0;
    .search_header {
      background: #ff6920;
      width: 235px;
      height: 45px;
      line-height: 45px;
      font-size: 18px;
      color: white;
      text-align: center;
      z-index: 99999;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/search/lableSearch.vue